// data/locksData.js
const locksData = [
  {
    id: 'lock1',
    color: '🟥 Red',
    title: 'Identifying Terms',
    paperData: ['5x + 3y + 7', '4x', '8x + 2y + 9 + x', '12', '3x + 4y', '6x + 1'],
    variants: [
      { prompt: "After simplifying, how many expressions have exactly 3 terms?", answer: "2" },
      { prompt: "How many expressions have only 1 term?", answer: "2" },
      { prompt: "After simplifying, what is the total number of terms in expression C?", answer: "3" }
    ]
  },
  {
    id: 'lock2',
    color: '🟧 Orange',
    title: 'Coefficients',
    paperData: ['8x', '3y + 7x', '5x + 12', 'x + 4y', '11x + 4', '9x + 2y'],
    variants: [
      { prompt: "Add all the coefficients of x together in A and B.", answer: "15" },
      { prompt: "Add all the coefficients of y together in A and B?", answer: "3" },
      { prompt: "In expression D, what is the sum of the coefficient of x and the coefficient of y?", answer: "5" }
    ]
  },
  {
    id: 'lock3',
    color: '🟨 Yellow',
    title: 'Combining Like Terms',
    paperData: ['7x + 2y - 4x + 9', '8y + 5y + 2y', '3x + 9x + x', '10x + 7x + 2x', '4a + 6a + 2b - 3a', '6x + 3x + 8x'],
    variants: [
      { prompt: "After simplifying expression A, what is the coefficient of x?", answer: "3" },
      { prompt: "Simplify expression D. What is the coefficient of x?", answer: "19" },
      { prompt: "Simplify expression E. What is the coefficient of a?", answer: "7" }
    ]
  },
  {
    id: 'lock4',
    color: '🟩 Green',
    title: 'Equivalent Expressions',
    paperData: ['4(x + 3)', '4x + 12', '3(2x + 5)', '6x + 15', '7(x + 2)'],
    variants: [
      { prompt: "How many groups of equivalent expressions are on the paper?", answer: "2" },
      { prompt: "Distribute expression E. What is the constant term?", answer: "14" },
      { prompt: "Which expression is NOT equivalent to any other? Write the letter", answer: "E" }
    ]
  },
  {
    id: 'lock5',
    color: '🟦 Blue',
    title: 'Distributive Property',
    paperData: ['5(3x + 2)', '3(2x + 4)', '6(x + 5)', '4(3x + 7)'],
    variants: [
      { prompt: "Distribute expression A. What is the coefficient of x?", answer: "15" },
      { prompt: "Distribute expression D. What is the constant term?", answer: "28" },
      { prompt: "After expressions A and B, what is the sum of the coefficients of x?", answer: "21" }
    ]
  },
{
    id: 'lock6',
    color: '🟪 Purple',
    title: 'Word Problems to Expressions',
    paperData: ['3x + 5', '3(x + 5)', '5x + 3', '5(x + 3)', '3x + 15', '15x + 3'],
    variants: [
      { prompt: "A library has 3 shelves. Each shelf has x mystery books and 5 adventure books. Which expression best shows the total number of books? Write the letter", answer: "B" },
      { prompt: "A bakery makes x batches of cookies with 3 cookies per batch, then makes 15 extra cookies. Which expression best shows the total number of cookies? Write the letter", answer: "E" },
      { prompt: "A garden has 5 rows. Each row has x tomato plants and 3 pepper plants. Which expression best shows the total number of plants? Write the letter", answer: "D" }
    ]
  },
  {
    id: 'lock7',
    color: '🟤 Brown',
    title: 'Mixed Practice',
    paperData: ['3(2x + 4)', '5x + 7x + 3x', '2(x + 6 + 2x) + 3x', '8x + 5x + 2', '4(x + 3) + 2x'],
    variants: [
      { prompt: "Simplify expression D. What is the coefficient of x?", answer: "13" },
      { prompt: "Simplify expression E. What is the constant term?", answer: "12" },
      { prompt: "After simplifying expressions A and B, how many have a coefficient of x greater than 10?", answer: "1" }
    ]
  },
  {
    id: 'lock8',
    color: '⬛ Black',
    title: 'BONUS CHALLENGE',
    paperData: ['x² + 4x', '5x + 20', 'x(x + 4)', '5(x + 4)', '2x² + 8x', 'x² + 5x + 4'],
    variants: [
      { prompt: "A square pool has side length x meters. A deck surrounds it, adding 2 meters to each side. Which expression is one way to write the deck's area? Write the letter", answer: "A" },
      { prompt: "A garden bed is x feet by (x+4) feet. You plant 2 identical garden beds. Which expression shows the total area?", answer: "E" },
      { prompt: "A garden bed is x feet by (x+4) feet. You plant 2 identical garden beds. Which expression shows the total area?", answer: "E" }
    ]
  }
];
export default locksData;